import * as React from "react";
import { Key } from "lucide-react";
import { Button } from "~/components/ui/button";
import { Input } from "~/components/ui/input";

// // // //

export interface ApiKeyInput {
    id?: string;
    name: string;
    archived: boolean;
}

export function ApiKeyForm(props: {
    apiKeyInput: ApiKeyInput;
    loading: boolean;
    onSubmit: (apiKeyInput: ApiKeyInput) => void;
}) {
    const { loading } = props;
    const [apiKeyInput, setApiKeyInput] = React.useState<ApiKeyInput>(
        props.apiKeyInput,
    );
    React.useEffect(() => {
        setApiKeyInput(props.apiKeyInput);
    }, [props.apiKeyInput]);

    return (
        <form
            autoComplete="off"
            onSubmit={(e) => {
                e.preventDefault();
                if (loading) {
                    return;
                }
                props.onSubmit(apiKeyInput);
            }}
        >
            <div className="bg-card border rounded p-6 select-none">
                <h3 className="font-semibold text-foreground mb-4">
                    Create New Key
                </h3>
                <div className="flex items-stretch gap-3">
                    <div className="flex-1">
                        <Input
                            required
                            value={apiKeyInput.name}
                            disabled={loading}
                            name="api-key-name"
                            placeholder="Key name (e.g., Production, Development)"
                            minLength={5}
                            maxLength={96}
                            className="h-11"
                            onChange={(e) =>
                                setApiKeyInput({
                                    ...apiKeyInput,
                                    name: e.target.value,
                                })
                            }
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    if (!loading && apiKeyInput.name.trim()) {
                                        props.onSubmit(apiKeyInput);
                                    }
                                }
                            }}
                        />
                    </div>
                    <Button
                        type="submit"
                        disabled={loading || !apiKeyInput.name.trim()}
                        className="h-11 px-6 bg-primary hover:bg-primary-hover text-white"
                    >
                        <Key className="size-4 mr-2" />
                        Create Key
                    </Button>
                </div>
                <p className="text-xs text-muted-foreground mt-3">
                    Give your key a descriptive name to help you identify it
                    later.
                </p>
            </div>
        </form>
    );
}
